export var SiteType;
(function (SiteType) {
    SiteType["twc"] = "TWC";
    SiteType["ilc"] = "ILC";
})(SiteType || (SiteType = {}));
